import { Module, Mutation, VuexModule } from 'vuex-module-decorators';

@Module({
	stateFactory: true,
	namespaced: false,
	name: 'currentUser'
})
export default class CurrentUser extends VuexModule {

	private _lang: string | null = null;
	private _referrer: string | null = null;

	get lang(): string {
		return this._lang;
	}

	get referrer(): string {
		return this._referrer;
	}

	@Mutation
	_setLang(lang: string) {
    this._lang = lang;
  }

  @Mutation
	_setReferrer(referrer: string) {
    this._referrer = referrer;
  }
}
